export default {
      id: "icon-P_CHURN-usage",
      viewBox: "0 0 32 26",
      url: "/" + "assets/sprite.svg#icon-P_CHURN",
      toString: function () {
        return this.url;
      }
    }